// export interface FUEL_ESCALATOR_TABLE_INTERFACE {
//     status: string, id: number, description: string, effectiveDate: string,  modifiedAt: string, createdAt: string, createdBy:string, modifiedBy:string
// }

export interface FUEL_ESCALATOR_TABLE_INTERFACE {
    FuelEscalatorID: number,
    FuelEscalatorDescription: any,
    FuelEscalatorEffectiveDate: string,
    CreatedOn: string,
    CreatedBy: string,
    ModifiedOn: string,
    ModifiedBy: string,
    CountryID: number,
    CountryofFuelIndex: string,
    IncludeTax: string,
    EscalatorValue: number,
    Selected?:boolean
}

export interface FUEL_PRICE_TABLE_INTERFACE {
    FuelEscalatorID: number,
    CountryID: number,
    CountryofFuelIndex: string,
    IncludeTax: string,
    EscalatorValue:number,
    CreatedOn:string,
    CreatedBy: string,
    ModifiedOn: string,
    ModifiedBy: string,
}

export const fuel_escalator_column_order = [
    {name:"Status", displayName:'Status' ,order : 1},
    {name: "FuelEscalatorID", displayName: "Escalator ID", order:2 },
    {name:"FuelEscalatorDescription", displayName:'Description' ,order : 3},
    {name:"FuelEscalatorEffectiveDate", displayName:'Effective Date' ,order : 4},
    {name:"CreatedOn", displayName:'Created (Date/Time)' ,order: 5},
    {name:"ModifiedOn", displayName:'Modified (Date/Time)' ,order : 6}
]

export const fuel_escalator_column_edit = [
    {name:"CountryofFuelIndex", displayName:'Country' , order : 1},
    {name:"IncludeTax", displayName:'Including Taxes' , order : 2},
    {name:"EscalatorValue", displayName:'Index Value' , order : 3},
    {name:"FuelEscalatorDescription",displayName:'Fuel Escalator Description' , order: 4},
    {name:"FuelEscalatorEffectiveDate", displayName:'Fuel Escalator Effective Date' , order : 5}
]